module.exports = __webpack_public_path__ + "img/setiabudi-socionomics-company.62d69ae2.png";